import React, { useEffect } from 'react';
import './washingmachine.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import WashDesc1 from '../images/washdesc1.jpg';
import WashDesc2 from '../images/washerdesc2.jpg';
import WashDesc3 from '../images/washerdesc3.jpg';
import Washergal1 from '../images/washergal1.webp'; // Adjust path as necessary
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faWrench, faTachometerAlt, faHome } from '@fortawesome/free-solid-svg-icons';



export default function WashingMachine() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);


  return (
    <div>
      <div><Navbar /></div>
      <div>
        <section id="hero" style={{ backgroundImage: `url(${Washergal1})` }}>
          <div className="hero-content">
            <h1>WASHING MACHINE SERVICE CENTER</h1>
            <p>Your Trusted Solution for All Appliance Repairs</p>
            <a href="tel:+919176849803" className="hero-btn">Book Service?</a>
          </div>
        </section>

        <section id="About">
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                <h2>About</h2>
                <p>Welcome to Sri Hari Home Care! With over six years of dedicated service in the industry, we are proud to be your trusted partner for washing machine repairs. We understand how essential a well-functioning washing machine is to your daily routine, and our expert team is here to ensure it performs at its best.

At Sri Hari Home Care, transparency is at the heart of our service. We know that trust is the foundation of our relationship with you, which is why we keep you informed at every step of the repair process. Our skilled technicians provide high-quality service, clearly explaining the costs and methods involved in restoring your washing machine.

Customer satisfaction is our top priority. We strive to offer timely, dependable service, so you can count on us whenever you need assistance. Whether it’s a minor adjustment or a major repair, our team is ready to help you get your washing machine back in perfect working order.

Thank you for choosing Sri Hari Home Care for your washing machine service needs—where quality service and customer trust always come first!</p>
              </div>
            </div>
          </div>
        </section>

        <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={WashDesc1} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>High Quality Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>At Sri Hari Home Care, we pride ourselves on delivering high-quality washing machine repair and maintenance services that ensure your appliance operates at peak performance. Our team of skilled technicians is proficient in servicing all brands and types of washing machines, including both front-load and top-load models. We exclusively use genuine parts for repairs, guaranteeing durability and efficiency in every service. With over six years of reliable service, Sri Hari Home Care upholds a commitment to transparency in pricing and process, instilling confidence in our customers. Our mission is to provide fast, dependable service that you can trust, allowing you to seamlessly return to your daily routine without interruption.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={WashDesc2} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Affordable Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Sri Hari Home Care provides affordable washing machine repair and maintenance services, ensuring your appliance remains in excellent working condition without breaking the bank. Our team of experienced technicians is equipped to handle all types of washing machines, from front-load to top-load models, across various brands. With over six years of trusted service, Sri Hari Home Care prioritizes transparency in pricing, offering honest diagnostics and quality repairs using genuine spare parts. We are dedicated to delivering timely and effective service, helping you maintain your washing machine’s performance and efficiency year-round, all while keeping costs manageable.</p>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={WashDesc3} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Best Service Center</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Sri Hari Home Care is your best choice for expert washing machine repair and maintenance services, ensuring your appliance keeps your laundry fresh and clean. Our skilled technicians are proficient in servicing all types of washing machines—whether front-load, top-load, or other models—across various brands. With six years of trusted experience, Sri Hari Home Care prioritizes transparency, providing clear pricing and dependable solutions for all washing machine issues. We utilize genuine parts and the latest tools to guarantee efficient repairs, optimizing your machine’s performance and reliability. Trust us for fast and effective service that keeps your washing machine running smoothly, allowing you to enjoy hassle-free laundry days.</p>
    </div>
  </div>
</section>






<section class="what-we-do">
  <div class="container">
    <h2>What We Do</h2>
    <p>At <strong>Sri Hari Home Care</strong>, we have been serving Chennai with pride for over <strong>6+ years</strong>, providing reliable and professional appliance repair services for washing machines, refrigerators, and air conditioners.</p>
    
    <div class="service-process">
      <div class="step">
        <h3>1. Easy Access</h3>
        <p>Our website is equipped with Google Ads, making it easy for customers to find us when they search for appliance repair services. With a quick phone call from our website, customers are instantly connected to our support team.</p>
      </div>
      <div class="step">
        <h3>2. Efficient Complaint Registration</h3>
        <p>Our customer support team registers the complaint and forwards it to a trained technician. Our team is committed to fast response times and customer satisfaction.</p>
      </div>
      <div class="step">
        <h3>3. Technician Appointment</h3>
        <p>Our technician contacts the customer to set up an appointment. We respect your time, arriving punctually and working efficiently.</p>
      </div>
      <div class="step">
        <h3>4. Quick and Reliable Repair</h3>
        <p>Upon arrival, our technician assesses the issue and repairs it within <strong>3-4 hours</strong>. If any spare parts need replacement, the technician shows the customer the faulty part and explains the need for a new one.</p>
      </div>
      <div class="step">
        <h3>5. Transparent and Fair Pricing</h3>
        <p>We charge a service fee of <strong>₹400</strong>. If any spare parts are replaced, they are charged at market rates, ensuring quality and transparency. All parts are opened in front of the customer for full confidence.</p>
      </div>
    </div>
  </div>
</section>





<section class="issues-section">
  <h2 class="section-heading">Issues in Washing Machine</h2>
  <div class="issues-container">
    
    <div class="issue-card">
      <i class="fas fa-tint icon"></i>
      <h3 class="issue-title">Water Leakage</h3>
      <p class="issue-description">Leaking water can be due to a damaged hose or improper drainage. It is essential to address this to prevent further issues.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-cogs icon"></i>
      <h3 class="issue-title">Drum Not Spinning</h3>
      <p class="issue-description">If the drum isn’t spinning, the motor or belt could be faulty. This common issue needs quick attention to avoid more severe damage.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-exclamation-triangle icon"></i>
      <h3 class="issue-title">Noisy Operation</h3>
      <p class="issue-description">A noisy washing machine can result from worn bearings or foreign objects. Timely repair can prevent costly replacements.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-plug icon"></i>
      <h3 class="issue-title">Power Issues</h3>
      <p class="issue-description">Power issues could indicate a problem with the control board or power supply. Professional diagnosis is needed to fix it safely.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-thermometer-half icon"></i>
      <h3 class="issue-title">Heating Problems</h3>
      <p class="issue-description">If the water isn't heating, it could be due to a broken heating element, affecting wash quality. Immediate service is advisable.</p>
    </div>

  </div>
</section>





        <section id="tech-spec" class="tech-special-section">
    <h2 class="section-title">Our Tech-Special</h2>
    <div class="tech-features-container">
        
        <div class="tech-feature">
            <i class="fas fa-cogs icon"></i>
            <h3>Work Performance</h3>
            <p>Our team delivers top-notch performance on every job, ensuring your appliances are handled with expert care and precision.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-clock icon"></i>
            <h3>Punctuality</h3>
            <p>We respect your time. Our technicians arrive on schedule and complete tasks within the estimated time frame.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-bolt icon"></i>
            <h3>Speed of Work</h3>
            <p>Efficiency is key. We complete repairs and maintenance swiftly without compromising on quality.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-headset icon"></i>
            <h3>Quick Response</h3>
            <p>Our customer service team is quick to respond to inquiries and schedule appointments with minimal delay.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-user-friends icon"></i>
            <h3>Friendly Technicians</h3>
            <p>Our technicians are not only skilled but also friendly and courteous, ensuring a positive service experience.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-broom icon"></i>
            <h3>Neat & Clean Work</h3>
            <p>We leave no mess behind. Our technicians ensure that your space is as clean as it was before the service.</p>
        </div>

    </div>
</section>



<section class="testimonials">
    <h2 class="section-title" id="testihead">Customer Testimonials</h2>
    <div class="testimonial-container">
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Our washing machine service was excellent! Very reliable and on time."</p>
            <p class="customer-name">- Kumar</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Professional washing machine repair service. My machine is running perfectly now."</p>
            <p class="customer-name">- Saravanan</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Quick and efficient repair service for our washing machine. Highly recommend!"</p>
            <p class="customer-name">- Augustin</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"The technician was very knowledgeable. My washing machine works like new now!"</p>
            <p class="customer-name">- Ramu</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Great service! My washing machine has been running smoothly since the repair."</p>
            <p class="customer-name">- Murugan</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Reliable and affordable washing machine repair. Very satisfied with the service!"</p>
            <p class="customer-name">- Ganesh</p>
        </div>
    </div>
</section>








        <section id="features" className="container my-5">
          <div className="row text-center">
            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faMoneyBillWave} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>No Initial Payment</h4>
                  <p>Enjoy peace of mind with our service-first policy. Pay only once the job is done to your satisfaction—no upfront costs!</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faWrench} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>Original Spare Parts</h4>
                  <p>We use only genuine spare parts for repairs, ensuring high performance and durability for your appliances.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faTachometerAlt} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>Speed Service</h4>
                  <p>Our team is dedicated to fast, efficient service to minimize your appliance downtime and get you back on track.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faHome} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>Doorstep Service</h4>
                  <p>Experience the convenience of professional appliance repair at your doorstep, saving you time and effort.</p>
                </div>
              </div>
            </div>
          </div>
        </section>



        <section class="opening-hours">
    <h2 class="section-title" id="Openhead">Opening Hours</h2>
    <div class="hours-container">
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Monday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Tuesday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Wednesday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Thursday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Friday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Saturday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day closed">
            <i class="day-icon fas fa-calendar-times"></i>
            <span>Sunday</span>
            <span>Closed</span>
        </div>
    </div>
</section>




<section id="customer-support">
    <h2 class="section-title">Customer Support</h2>
    <div class="container">
        <div class="row">
           
            <div class="col-md-4 col-sm-12">
                <div class="card support-card">
                    <div class="icon-container">
                        <i class="fas fa-phone-alt"></i>
                    </div>
                    <h4 class="card-title">Tele-calling Team</h4>
                    <p class="card-text">
                        Our dedicated tele-calling team is always ready to assist you with inquiries, ensuring quick responses and personalized support.
                    </p>
                </div>
            </div>
           
            <div class="col-md-4 col-sm-12">
                <div class="card support-card">
                    <div class="icon-container">
                        <i class="fas fa-headset"></i>
                    </div>
                    <h4 class="card-title">24X7 Customer Support</h4>
                    <p class="card-text">
                        Our customer support is available 24/7, ready to help you with any issues or questions you may have at any time of day or night.
                    </p>
                </div>
            </div>
         
            <div class="col-md-4 col-sm-12">
                <div class="card support-card">
                    <div class="icon-container">
                        <i class="fas fa-tools"></i>
                    </div>
                    <h4 class="card-title">Technician Arranging Incharge Team</h4>
                    <p class="card-text">
                        Our expert technician arranging incharge team ensures that the right professionals are dispatched to your location quickly and efficiently.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>


<section id="faq-section" class="faq-section">
    <div class="container">
        <h2 class="section-title">FAQ for Washing Machine Service</h2>

        <div class="faq-card">
            <h4 class="faq-question">What causes water leakage in a washing machine?</h4>
            <p class="faq-answer">
                Water leakage can be due to a damaged hose, improper drainage, or worn-out seals. Professional inspection is advised to identify and fix the issue effectively.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">Why isn’t my washing machine drum spinning?</h4>
            <p class="faq-answer">
                A non-spinning drum could indicate issues with the motor, belt, or lid switch. It's recommended to have a technician examine and repair it promptly.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">How often should I clean my washing machine?</h4>
            <p class="faq-answer">
                Cleaning the washing machine every month helps to maintain its performance. Regular cleaning prevents mold, mildew, and unpleasant odors.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">What should I do if my washing machine makes a loud noise?</h4>
            <p class="faq-answer">
                Loud noises can be caused by unbalanced loads or issues with the drum bearings or motor. It's best to get it checked by a professional.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">How do I remove lint from my washing machine?</h4>
            <p class="faq-answer">
                Lint can be removed by cleaning the filter regularly and wiping the drum after each wash. Some machines have a dedicated lint filter for easy cleaning.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">What causes detergent residue on clothes?</h4>
            <p class="faq-answer">
                Detergent residue can result from using too much detergent or washing with cold water. Use recommended detergent amounts and run an extra rinse cycle if needed.
            </p>
        </div>
    </div>
</section>

<section id="disclaimer" class="disclaimer-section">
    <div class="disclaimer-content">
        <h2 class="disclaimer-title">Disclaimer</h2>
        <p class="disclaimer-text">
            Sri Hari Home Care is not authorized by any specific brand. We are a multibrand service provider offering assistance for a variety of home appliances.
        </p>
    </div>
</section>

      </div>
      <div><Footer /></div>
    </div>
  )
}
